import React, { createContext, useState, ReactNode } from 'react';
import { ItemNav } from 'types/itemNavBar';
import { optionsNav } from 'components/Navbar/options';

interface NavBarContextProviderProps {
	isOpen: boolean;
	setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
	isReq: boolean;
	setIsReq: React.Dispatch<React.SetStateAction<boolean>>;
	isErrorReq: boolean;
	setIsErrorReq: React.Dispatch<React.SetStateAction<boolean>>;
	listNavBar: ItemNav[];
	setListNavBar: React.Dispatch<React.SetStateAction<ItemNav[]>>;
}

const NavBarContextContext = createContext<NavBarContextProviderProps>({
	isOpen: true,
	setIsOpen: () => {},
	isReq: true,
	setIsReq: () => {},
	isErrorReq: true,
	setIsErrorReq: () => {},
	listNavBar: [],
	setListNavBar: () => {}
});

interface ContextProps {
	children: ReactNode;
}

export function NavBarProvider({ children }: ContextProps) {
	const [isOpen, setIsOpen] = useState(true);
	const [isReq, setIsReq] = useState(false);
	const [isErrorReq, setIsErrorReq] = useState(false);
	const [listNavBar, setListNavBar] = useState<ItemNav[]>(optionsNav);

	return (
		<NavBarContextContext.Provider
			value={{
				isOpen,
				setIsOpen,
				isReq,
				setIsReq,
				isErrorReq,
				setIsErrorReq,
				listNavBar,
				setListNavBar
			}}
		>
			{children}
		</NavBarContextContext.Provider>
	);
}

export default NavBarContextContext;
